import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../Assets/Css/Pages/ProductsList/banners.css";
import {ReactElement} from "react";
import {useSynchronizeProductListBanners} from "./Hooks/useSynchronizeProductListBanners";
import {ProductListBannerCarousel} from "./ProductListBannerCarousel";

export function ProductListBanners(): ReactElement | null {
    const banners = useSynchronizeProductListBanners();

    if (banners.length === 0) {
        return null;
    }

    return <ProductListBannerCarousel />;
}
